export const UpdtInvoiceContAction = {
    AddUpdtInvoiceContent: "ADDUPDTINVOICECONTENT",
    UpdateInvoiceContent:"UPDATEINVOICECONTENT",
    RemoveUpdtInvoiceContent: "REMOVEUPDTINVOICECONTENT",
    RemoveAllUpdtInvoiceContent: "REMOVEALLUPDTINVOICECONTENT"
}

const udpatedInvoiceContent = [];

const UpdatedInvoiceContentReducer = (updtInvCont = udpatedInvoiceContent, actions) => {
    switch (actions.type) {
        case UpdtInvoiceContAction.AddUpdtInvoiceContent:
            //  return { ...updtGoals, ...actions.payload };
            updtInvCont.push(actions.payload);
            return updtInvCont;
        case UpdtInvoiceContAction.UpdateInvoiceContent:
            if (updtInvCont.length > 0) {
                const updtInvContCopy = [...updtInvCont];
                const index = updtInvContCopy.findIndex(u => u.Id === actions.payload.Id);
                if (index !== -1) {
                    updtInvContCopy[index] = { ...updtInvContCopy[index], ...actions.payload };
                }
                updtInvCont = [];
                updtInvCont = updtInvContCopy;
            } else {
                updtInvCont.push(actions.payload);
            }
            return updtInvCont;

        case UpdtInvoiceContAction.RemoveUpdtInvoiceContent:
            // updtGoals = [];
            var res = updtInvCont.filter((item) => item.MeetingId !== actions.payload);
            updtInvCont = [];
            updtInvCont = res;

            return updtInvCont;
        case UpdtInvoiceContAction.RemoveAllUpdtInvoiceContent:
            updtInvCont = [];
            return updtInvCont;

        default:
            // updtInvCont = [];
            return updtInvCont;
    }
}
export default UpdatedInvoiceContentReducer;